import React from 'react';
import { Container, Row, Col, Card, ListGroup, Breadcrumb, Badge } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { categories } from '../data/categories';

// Fix for Leaflet marker icons
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const SubcategoryPage = () => {
  const { categoryId, subcategoryId } = useParams();
  const category = categories.find(cat => cat.id === categoryId);
  const subcategory = category?.subcategories.find(sub => sub.id === subcategoryId);

  if (!category || !subcategory) {
    return (
      <Container className="py-5">
        <h1>Subcategory Not Found</h1>
        <p>The subcategory you're looking for doesn't exist.</p>
        <Link to="/">Return to Home</Link>
      </Container>
    );
  }

  // Generate random coordinates for Jamaica for demo purposes
  const getRandomJamaicaCoordinates = () => {
    return [
      18.1096 + (Math.random() - 0.5) * 0.5,
      -77.2975 + (Math.random() - 0.5) * 0.5
    ];
  };

  return (
    <Container className="py-5">
      <Breadcrumb>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/category/${categoryId}` }}>{category.title}</Breadcrumb.Item>
        <Breadcrumb.Item active>{subcategory.title}</Breadcrumb.Item>
      </Breadcrumb>

      <h1 className="mb-4">{subcategory.title}</h1>
      <p className="lead mb-5">Explore the best {subcategory.title.toLowerCase()} in Jamaica.</p>

      <Row className="mb-5">
        <Col>
          <div style={{ height: '400px', width: '100%', borderRadius: '10px', overflow: 'hidden' }}>
            <MapContainer 
              center={[18.1096, -77.2975]} 
              zoom={8} 
              style={{ height: '100%', width: '100%' }}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
              {subcategory.items.map((item) => (
                <Marker 
                  key={item.id}
                  position={getRandomJamaicaCoordinates()}
                >
                  <Popup>
                    <strong>{item.name}</strong><br />
                    {item.location}<br />
                    Rating: {item.rating}/5<br />
                    <Link to={`/listing/${categoryId}/${subcategoryId}/${item.id}`}>
                      View Details
                    </Link>
                  </Popup>
                </Marker>
              ))}
            </MapContainer>
          </div>
        </Col>
      </Row>

      <Row>
        {subcategory.items.map(item => (
          <Col key={item.id} md={6} lg={4} className="mb-4">
            <Card className="h-100 shadow-sm hover-card">
              <Card.Body>
                <Card.Title>{item.name}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">{item.location}</Card.Subtitle>
                <div className="mb-3">
                  <Badge bg="success">Rating: {item.rating}/5</Badge>
                </div>
                <Link 
                  to={`/listing/${categoryId}/${subcategoryId}/${item.id}`}
                  className="btn btn-primary"
                >
                  View Details
                </Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default SubcategoryPage;
